import React from 'react';

const defaultStyle =
  'block rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 h-8';
const trashCanIconStyle = 'text-rose-500 hover:text-rose-600 rounded-full ';

export default function DeleteButton({ onClick, trashCanIcon }) {
  return (
    <button
      onClick={onClick}
      type="button"
      className={trashCanIcon ? trashCanIconStyle : defaultStyle}
    >
      <span className="sr-only">Delete</span>
      {trashCanIcon ? (
        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
          <path d="M13 15h2v6h-2zM17 15h2v6h-2z" />
          <path d="M20 9c0-.6-.4-1-1-1h-6c-.6 0-1 .4-1 1v2H8v2h1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V13h1v-2h-4V9zm-6 1h4v1h-4v-1zm7 3v9H11v-9h10z" />
        </svg>
      ) : (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <path
            className="fill-current"
            d="M15.95 14.536l4.242-4.243a1 1 0 111.415 1.414l-4.243 4.243 4.243 4.242a1 1 0 11-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 01-1.414-1.415l4.243-4.242-4.243-4.243a1 1 0 011.414-1.414l4.243 4.243z"
          />
        </svg>
      )}
    </button>
  );
}
